<template>
  <!-- Main Sidebar Container -->
  <aside
    v-show="isAuthenticated"
    class="main-sidebar sidebar-dark-primary elevation-4"
    ref="sideBar"
  >
    <!-- Brand Logo -->
    <router-link
      to="/"
      class="brand-link logo-switch"
      style="background-color: #c2c7d0"
    >
      <img class="brand-image-xl logo-xs" src="../assets/img/favicon-32x32.png" alt="ERN Logo" />
      <span class="brand-text font-weight-light">
        <img
          class="brand-image-xs logo-xl"
          style="width: 80%; margin-top: 1px"
          src="../assets/img/logo.svg"
          alt="ERN logo"
        />
      </span>
    </router-link>

    <!-- Sidebar -->
    <div class="sidebar">
      <!-- Sidebar user panel (optional) -->
      <div class="user-panel mt-3 pb-3 mb-3 d-flex">
        <div class="image">
          <div
            class="profile-photo"
            :style="{ backgroundImage: `url(${getImagePath(userPhoto)})` }"
          ></div>
        </div>
        <div class="info">
          <a href="#" class="d-block">{{ userFullName }}</a>
        </div>
      </div>

      <!-- SidebarSearch Form -->
      <div class="form-inline">
        <div class="input-group" data-widget="sidebar-search">
          <input
            class="form-control form-control-sidebar"
            type="search"
            placeholder="Search"
            aria-label="Search"
          />
          <div class="input-group-append">
            <button class="btn btn-sidebar">
              <i class="fas fa-search fa-fw"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- Sidebar Menu -->
      <nav class="mt-2">
        <ul
          class="nav nav-pills nav-sidebar flex-column"
          data-widget="treeview"
          role="menu"
          data-accordion="false"
        >
          <!-- Add icons to the links using the .nav-icon class
               with font-awesome or any other icon font library -->
          <li class="nav-item" v-if="ifHrOperation">
            <a href="#" class="nav-link">
              <i class="nav-icon fas fa-copy"></i>
              <p>
                Talent & Culture
                <i class="fas fa-angle-left right"></i>
                <!-- <span class="right badge badge-danger">6</span> -->
              </p>
            </a>
            <ul class="nav nav-treeview">
              <li class="nav-item">
                <router-link to="/application/" class="nav-link">
                  <i class="nav-icon far fa-circle"></i>
                  <p>Applications</p>
                </router-link>
              </li>
            </ul>
          </li>
          <li class="nav-item" v-if="ifNotEmployee && !ifViewer">
            <a href="#" class="nav-link">
              <i class="nav-icon fas fa-user"></i>
              <p>
                Operation
                <i class="fas fa-angle-left right"></i>
              </p>
            </a>
            <ul class="nav nav-treeview">
              <li class="nav-item">
                <router-link to="/employee/" class="nav-link">
                  <i class="nav-icon far fa-circle"></i>
                  <p>Employees</p>
                </router-link>
              </li>
              <li class="nav-item">
                <router-link to="/teams-admin/" class="nav-link" v-if="ifOperation">
                  <i class="nav-icon far fa-circle"></i>
                  <p>Teams Admin</p>
                </router-link>
              </li>
              <li class="nav-item">
                <router-link to="/tasks-admin/" class="nav-link" v-if="ifOperation">
                  <i class="nav-icon far fa-circle"></i>
                  <p>Tasks Admin</p>
                </router-link>
              </li>
            </ul>
          </li>
          <li class="nav-item">
            <a href="#" class="nav-link">
              <i class="nav-icon fas fa-clock"></i>
              <p>
                Time Tracker
                <i class="fas fa-angle-left right"></i>
              </p>
            </a>
            <ul class="nav nav-treeview" v-if="!ifViewer">
              <li class="nav-item">
                <router-link to="/time-tracker/" class="nav-link">
                  <i class="nav-icon far fa-circle"></i>
                  <p>Time Entry</p>
                </router-link>
              </li>
            </ul>
            <ul class="nav nav-treeview">
              <li class="nav-item">
                <router-link to="/time-tracker/report/" class="nav-link">
                  <i class="nav-icon far fa-circle"></i>
                  <p>Detailed Report</p>
                </router-link>
              </li>
            </ul>
            <ul class="nav nav-treeview" v-if="!ifViewer">
              <li class="nav-item">
                <router-link to="/time-tracker/kpi/" class="nav-link">
                  <i class="nav-icon far fa-circle"></i>
                  <p>KPI Report</p>
                </router-link>
              </li>
            </ul>
            <ul v-if="ifNotEmployee && !ifViewer" class="nav nav-treeview">
              <li class="nav-item">
                <router-link to="/time-tracker/aht/" class="nav-link">
                  <i class="nav-icon far fa-circle"></i>
                  <p>AHT Report</p>
                </router-link>
              </li>
            </ul>
            <ul v-if="ifNotEmployee && !ifViewer" class="nav nav-treeview">
              <li class="nav-item">
                <router-link to="/time-tracker/week-monitor/" class="nav-link">
                  <i class="nav-icon far fa-circle"></i>
                  <p>Week Monitor</p>
                </router-link>
              </li>
            </ul>
            <!-- <ul class="nav nav-treeview">
              <li class="nav-item">
                <router-link
                  to="/time-tracker/report-summary/"
                  class="nav-link"
                >
                  <i class="nav-icon far fa-circle"></i>
                  <p>Summarized Report</p>
                </router-link>
              </li>
            </ul> -->
            <ul v-if="ifNotEmployee" class="nav nav-treeview">
              <li class="nav-item">
                <router-link to="/time-tracker/monitor/" class="nav-link">
                  <i class="nav-icon far fa-circle"></i>
                  <p>Tasks Monitor</p>
                </router-link>
              </li>
            </ul>
            <ul class="nav nav-treeview" v-if="!ifViewer">
              <li class="nav-item">
                <router-link to="/time-tracker/quality-kpi/" class="nav-link">
                  <i class="nav-icon far fa-circle"></i>
                  <p>Quality KPI</p>
                </router-link>
              </li>
            </ul>
          </li>
        </ul>
      </nav>
      <!-- /.sidebar-menu -->
    </div>
    <!-- /.sidebar -->
  </aside>
</template>

<script>
export default {
  computed: {
    isAuthenticated() {
      return this.$store.getters['users/isAuthenticated'];
    },
    userPhoto() {
      const currentUser = this.$store.getters['users/userInfo'];
      return `${currentUser.user_photo}`;
    },
    userFullName() {
      const currentUser = this.$store.getters['users/userInfo'];
      return `${currentUser.firstName} ${currentUser.lastName}`;
    },
    ifHr() {
      const { userType } = this.$store.getters['users/userInfo'];
      const arr = ['admin', 'hr'];
      return arr.includes(userType);
    },
    ifHrOperation() {
      const { userType } = this.$store.getters['users/userInfo'];
      const arr = ['admin', 'hr', 'operation'];
      return arr.includes(userType);
    },
    ifNotEmployee() {
      const { userType } = this.$store.getters['users/userInfo'];
      return userType !== 'employee';
    },
    ifOperation() {
      const { userType } = this.$store.getters['users/userInfo'];
      const arr = ['admin', 'operation'];
      return arr.includes(userType);
    },
    ifViewer() {
      const { userType } = this.$store.getters['users/userInfo'];
      return userType === 'viewer';
    },
  },
  created() {},
  mounted() {},
  data() {
    return {
      applications: [
        { name: 'New', color: 'text-info', link: 'new' },
        { name: 'On Hold', color: 'text-warning', link: 'on-hold' },
        { name: 'Rejected', color: 'text-danger', link: 'rejected' },
        { name: 'Blacklisted', color: 'text-secondary', link: 'blacklisted' },
        { name: 'Accepted', color: 'text-success', link: 'accepted' },
      ],
    };
  },
  methods: {
    getImagePath(imageSrc) {
      console.log(process.env.VUE_APP_ENV === 'prod');
      return process.env.VUE_APP_ENV === 'prod'
        ? imageSrc
        : `${process.env.VUE_APP_BASE_URL}${imageSrc}`;
    },
  },
};
</script>

<style>
.d-block {
  text-transform: capitalize;
}

.menu-is-opening a .fa-angle-left {
  transform: rotate(-90deg);
}
.profile-photo {
  width: 40px !important;
  height: 40px !important;
  background-repeat: no-repeat;
  background-size: cover;
  background-clip: 100%;
  border-radius: 50%;
  background-position: top center;
}
</style>
